import { render } from "./IconBtn.vue?vue&type=template&id=8e631eaa"
import script from "./IconBtn.vue?vue&type=script&lang=js"
export * from "./IconBtn.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/night.nana7mi.link/night.nana7mi.link/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__